module.exports = __webpack_public_path__ + "img/cv-template-12.8a659039.png";